'use client';

import { NetworkLink } from '@/components/ui/NetworkLink';
import { SearchInput } from '@/components/ui/SearchInput';
import { Button } from '@/components/ui/button';
import { SparkScanLogo } from '@/components/ui/icons';
import { Home } from 'lucide-react';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();

  return (
    <div className="container flex flex-col items-center justify-center min-h-[calc(100vh-14rem)] text-center px-4">
      <div className="space-y-8 w-full">
        <SparkScanLogo className="h-12 w-12 mx-auto mb-2" />

        <h1 className="text-4xl font-bold tracking-tight">Not Found</h1>

        {/* Search Input */}
        <div className="pt-4">
          <p className="text-sm text-muted-foreground mb-2">Try searching for something else:</p>
          <SearchInput
            className="w-1/2 mx-auto"
            placeholder="Search for accounts, tokens..."
            onSearch={(query) => {
              console.log('Search from 404 page:', query);
            }}
          />
        </div>

        {/* Navigation Options */}
        <div className="flex flex-col items-center justify-center gap-4 pt-6">
          <Button asChild className="w-full sm:w-40">
            <NetworkLink href="/">
              <Home className="mr-2 h-4 w-4" />
              Return Home
            </NetworkLink>
          </Button>

          <Button onClick={() => router.back()} variant="outline" className="w-full sm:w-40">
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
